import Constant from '@/const';
import axios from 'axios';

const postInformedConsent = async (idEMR, payload) => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/document/inform-consent/${idEMR}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postInformedConsent;
